
import './adjust-financial-plan-input.scss';
import React, { HTMLProps } from 'react'


interface AdjustFinancialPlanInputInterface extends HTMLProps<HTMLInputElement> {
  variant?: 'full' | 'small';
  prefix?: string;
  postfix?: string;
  value: string | number;
}

const AdjustFinancialPlanInput = ({ variant = 'full', ...props }: AdjustFinancialPlanInputInterface) => {


  return (
    <div className='polymer-adjust-financial-plan-input-wrapper'>
      <div className={`polymer-adjust-financial-plan-input ${variant === 'small' ? 'polymer-adjust-financial-plan-input-small' : ''} `}>
        {props.prefix && <div className='polymer-adjust-financial-plan-input__prefix-container'>
          <p>{props.prefix}</p>
        </div>}
        <div className='polymer-adjust-financial-plan-input__value-container'>
          <input value={props.value} inputMode='decimal' type="number" maxLength={props.maxLength} placeholder={props.placeholder} onBlur={props.onBlur} onChange={props.onChange} onFocus={props.onFocus} />
        </div>
      </div>
      {props.postfix && <div className='polymer-adjust-financial-plan-input__postfix-container'>
        <p>{props.postfix}</p>
      </div>}
    </div>
  )
}

export default AdjustFinancialPlanInput